import * as preact from "preact";
import { $$ } from "../../Core/Common";
import { AutoCompleteGroup } from "../../Common/AutoCompleteGroup/AutoCompleteGroup";
import { CheckBox } from "../../Common/CheckBox/CheckBox";
import { DataLabel } from "../../Common/DataLabel/DataLabel";
import { DataPanel, IDataPanelProps } from "../../Common/DataPanel/DataPanel";
import { EventEditor } from "../EventEditor/EventEditor";
import { FlexDate } from "../../Common/FlexDate/FlexDate";
import { MultiTextBox } from "../../Common/MultiTextBox/MultiTextBox";
import { TextBox } from "../../Common/TextBox/TextBox";
import { VideoSelector } from "../../Common/VideoSelector/VideoSelector";

import Topic = EventLibrary.Model.Topic;
import { $$requestManager } from "../../Core/RequestManager";


export interface ITopicEditorProps extends IDataPanelProps<Topic>
{
    onCancel?: Function;
    onSave?: Function;
}

export class TopicEditor extends DataPanel<Topic, ITopicEditorProps>
{
    private _btnClear: HTMLElement;
    private _btnSave: HTMLInputElement;
    private _chkNeedsPopulation: CheckBox;
    private _clearImage: boolean;
    private _txtName: TextBox;
    private _txtPopCount: TextBox;
    private _autoGroupParent: AutoCompleteGroup;
    private _fileInput: HTMLInputElement;
    private _imageContent: string;
    private _imageFilename: string;
    private _imgPerson: HTMLImageElement;
    private _lnkWikipedia: HTMLAnchorElement;
    private _pnlBirthDeath: HTMLElement;
    private _pnlParentTopics: HTMLElement;
    private _pnlStartEnd: HTMLElement;
    private _pnlAIPopulationSetup: HTMLElement;
    private _pnlAIPopulationCount: HTMLElement;
    private _txtWikipediaTitle: TextBox;

    public constructor(props: ITopicEditorProps)
    {
        super(props);
        this.addDataProperty("Id");
    }

    public override clearData()
    {
        super.clearData();
        this._updateWikiLink("");
        this._imgPerson.src = "";
    }

    public override componentDidMount()
    {
        super.componentDidMount();
        this._txtName.focus();
    }

    private _handleClearClick()
    {
        this.clearData();
    }

    private _handleSaveClick()
    {
        $$requestManager.execute("api/event/SaveTopic", this.getData(), this._onSaveSuccess.bind(this));
    }

    private _onSaveSuccess(eventGroup)
    {
        this.setData(eventGroup);
        if (this.props.onSave)
        {
            this.props.onSave(eventGroup);
        }
    }

    public override getData(data?: EventLibrary.Model.Topic): EventLibrary.Model.Topic
    {
        data = super.getData(data);
        data.PopulationCount = data.PopulationCount || 0;
        data.ImageContent = this._imageContent;
        data.ImageFilename = this._imageFilename;
        data.ClearImage = this._clearImage;

        return data;
    }

    public override setData(data: EventLibrary.Model.Topic)
    {
        super.setData(data);
        $$.trace(data?.TopicType);
        if (data.TopicType === 1)
        {
            $$.hide(this._pnlStartEnd);
            $$.hide(this._pnlParentTopics);
            $$.show(this._pnlBirthDeath);
        }
        else
        {
            $$.hide(this._pnlBirthDeath);
            $$.show(this._pnlParentTopics);
            $$.show(this._pnlStartEnd);
        }

        this._autoGroupParent.setValue(data?.ParentTopics);
        if (data?.Id)
        {
            $$.hide(this._btnClear);
            this._autoGroupParent.setExclusions([data.Id.toString()]);
        }
        else
        {
            $$.show(this._btnClear);
        }


        this._clearImage = false;
        this._updateWikiLink(data.WikipediaPageTitle);
        this._imgPerson.src = "api/image/GetImage?personid=" + (data.Id || "");

        if (data?.AutoPopulatedEvents)
        {
            $$.hide(this._pnlAIPopulationSetup);
            $$.show(this._pnlAIPopulationCount);
        }
        else
        {
            $$.hide(this._pnlAIPopulationCount);
            $$.show(this._pnlAIPopulationSetup);

            if (data?.NeedsPopulation)
            {
                this._txtPopCount.show();
            }
            else
            {
                this._txtPopCount.hide();
            }
        }
    }

    /**
     * Updates the test wikipedia link
     * @param title
     */
    private _updateWikiLink(title): void
    {
        this._lnkWikipedia.href = "https://en.wikipedia.org/wiki/" + (title || "");
        this._lnkWikipedia.innerHTML = this._lnkWikipedia.href;
    }

    /**
     * onTitle change handler
     */
    private onTitleChange(): void
    {
        this._updateWikiLink(this._txtWikipediaTitle.getValue());
    }

    private _onChkNeedsPopulationChange()
    {
        if (this._chkNeedsPopulation.getValue())
        {
            this._txtPopCount.show();
            this._txtPopCount.setValue(100);
        }
        else
        {
            this._txtPopCount.hide();
        }
    }

    private onChangeFile(event)
    {
        var files = this._fileInput.files;
        if (files.length === 0)
        {
            return;
        }

        var file = files[0];
        var reader = new FileReader();
        this._btnSave.disabled = true;
        reader.onloadend = () =>
        {
            this._btnSave.disabled = false;
            this._imgPerson.src = reader.result as string;
            this._imageContent = reader.result as string;
            this._imageFilename = file.name;
            this._clearImage = false;
        };
        reader.readAsDataURL(file);
    }

    private handleClearImageClick()
    {
        this._imageFilename = null;
        this._imageContent = null;
        this._imgPerson.src = "api/image/GetImage?personid=-1";
        this._clearImage = true;
    }


    public render()
    {
        return (
            <div ref={(ref) => this._registerContainer(ref)} style={{ whiteSpace: "nowrap" }}>
                <div style={{ display: "inline-block", verticalAlign: "top", paddingRight: "15px", textAlign: "center" }}>
                    <img ref={(ref) => { this._imgPerson = ref; }}
                        style={{ width: "150px", boxShadow: "0px 0px 2px 1px #777", borderRadius: "2px" }} /><br />
                    <input ref={(ref) => { this._fileInput = ref; }} type="file" accept="image/png, image/jpeg" style={{ color: "transparent", width: "90px" }} onChange={this.onChangeFile.bind(this)} /><br />
                    <a href="javascript:void(0);" style={{ marginTop: "4px", fontSize: "9pt", display: "inline-block" }} onClick={this.handleClearImageClick.bind(this)}>Clear image</a>
                </div>
                <div style={{ display: "inline-block", paddingRight: "50px" }} >
                    <div className="formElement">
                        <TextBox Descriptor="Name" ref={(ref) => { this.addDataControl(ref, "Name"); this._txtName = ref; }} style={{ width: "400px" }} />
                    </div>

                    <div className="formElement">
                        <TextBox ref={(ref) => this.addDataControl(ref, "Descriptor")} Descriptor="Descriptor" style={{ width: "400px" }} />
                    </div>

                    <div className="formElement">
                        <MultiTextBox Descriptor="Other Names Known By" ref={(ref) => this.addDataControl(ref, "Synonyms")} />
                    </div>

                    <div ref={(ref)=> this._pnlParentTopics = ref } className="formElement">
                        <AutoCompleteGroup Descriptor="Parent Topics" ref={(ref) => { this.addDataControl(ref, "ParentTopicIds", null, null, true); this._autoGroupParent = ref; }}
                            LookupService="api/event/GetTopics" />
                    </div>

                    <div className="formElement">
                        <TextBox Descriptor="Summary" ref={(ref) => this.addDataControl(ref, "Summary")} IsMultiLine={true} style={{ width: "400px", height: "200px" }} />
                    </div>

                    <div className="formElement">
                        <TextBox ref={(ref) => { this._txtWikipediaTitle = ref; this.addDataControl(ref, "WikipediaPageTitle"); }} Descriptor="Wikipedia Title" style={{ width: "400px" }} onChange={this.onTitleChange.bind(this)} />
                        <br />
                        <a target="_blank" ref={(ref) => this._lnkWikipedia = ref} />
                    </div>

                    <div ref={(ref) => this._pnlBirthDeath = ref}>
                        <div style={{ paddingTop: "20px" }}>
                            Birth Info
                            <br /><br />
                            <EventEditor ref={(ref) => this.addDataPanel(ref, "BirthEvent")} Simple={true} />
                        </div>

                        <div style={{ paddingTop: "20px" }}>
                            Death Info
                            <br /><br />
                            <EventEditor ref={(ref) => this.addDataPanel(ref, "DeathEvent")} Simple={true} />
                        </div>
                    </div>

                    <div ref={(ref) => this._pnlStartEnd = ref}>
                        <div className="formElement">
                            <FlexDate Descriptor="Start Date" ref={(ref) => this.addDataControl(ref, "Start")} />
                        </div>
                        <div className="formElement">
                            <FlexDate Descriptor="End Date" ref={(ref) => this.addDataControl(ref, "End")} />
                        </div>
                    </div>

                    <div className="formElement">
                        <VideoSelector ref={(ref) => { this.addDataPanel(ref, "Videos") }} style={{ paddingTop: "25px" }} />
                    </div>

                    <label className="labelHeader">Content Generation</label>
                    <div ref={(ref) => this._pnlAIPopulationCount = ref} className="formElement">
                        # Events Auto-Populated: <DataLabel ref={(ref) => this.addDataControl(ref, "AutoPopulatedEvents")} />
                    </div>

                    <div ref={(ref) => this._pnlAIPopulationSetup = ref} className="formElement" style={{ paddingTop: "5px" }}>
                        <CheckBox text="Needs AI Population" ref={(ref) => { this.addDataControl(ref, "NeedsPopulation"); this._chkNeedsPopulation = ref; }} onChange={this._onChkNeedsPopulationChange.bind(this)} style={{ marginTop: "4px", display: "inline-block" }} />
                        <TextBox Descriptor="Population Count" ref={(ref) => { this.addDataControl(ref, "PopulationCount"); this._txtPopCount = ref; }} style={{ marginLeft: "15px", width: "100px" }} />
                    </div>

                    <div style={{ textAlign: "right" }}>
                        <input ref={(ref) => this._btnSave = ref} type="button" value="Save" onClick={this._handleSaveClick.bind(this)} style={{ marginRight: "10px" }}></input>
                        <input ref={(ref) => this._btnClear = ref} type="button" value="Clear" onClick={this._handleClearClick.bind(this)}></input>
                        <input type="button" onClick={this.props.onCancel as any} value="Cancel" />
                    </div>
                </div>
            </div>);
    }
}